/* 🤖 this file was generated by svg-to-ts */
export const matIconSettingsRemote: {
  name: 'settings-remote';
  data: string;
} = {
  name: 'settings-remote',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-1 12h-4V11h4v10z"/><circle cx="12" cy="13" r="1"/><path d="m7.05 6.05 1.41 1.41a5.022 5.022 0 0 1 7.08 0l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"/></svg>`
};
